import { render, staticRenderFns } from "./MADDPreview.vue?vue&type=template&id=03a6a564&scoped=true"
import script from "./MADDPreview.vue?vue&type=script&lang=js"
export * from "./MADDPreview.vue?vue&type=script&lang=js"
import style0 from "./MADDPreview.vue?vue&type=style&index=0&id=03a6a564&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a6a564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a6a564')) {
      api.createRecord('03a6a564', component.options)
    } else {
      api.reload('03a6a564', component.options)
    }
    module.hot.accept("./MADDPreview.vue?vue&type=template&id=03a6a564&scoped=true", function () {
      api.rerender('03a6a564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/MADD/MADDPreview.vue"
export default component.exports